import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import AppointmentInformation from './AppointmentInformation'
import useTranslation from '../../../utils/translation'
import PageTitle from '../../components/typography/pageTitle'

const Heading = styled(PageTitle)`
  text-align: center;
  margin: ${theme('amend.step3.heading.margin')};
  max-width: ${theme('amend.step3.heading.maxWidth')};
  color: ${(props) => theme('amend.step3.heading.color')(props)};
`

const Preamble = styled.p`
  font-family: ${theme('typography.paragraph.fontFamily')};
  text-align: center;
  font-size: 18px;
  max-width: 600px;
  max-width: 475px;
  margin: 0px auto 50px auto;
  display: block;
  line-height: 27px;
`

const Link = styled.a`
  font-family: ${theme('typography.paragraph.fontFamily')};
  color: ${theme('amend.step3.link.color')};
  font-size: ${theme('amend.step3.link.fontSize')};
  text-align: center;
  display: block;
  margin-top: 40px;
`

const AmendStep3 = ({appointment, store, pageContentServices}) => {
  const t = useTranslation('amend.step3')

  return (
    <>
      <Heading>{t('heading')}</Heading>
      <Preamble>{t('preamble')}</Preamble>
      <AppointmentInformation
        appointment={appointment}
        store={store}
        pageContentServices={pageContentServices}
      />
      <Link href={window.location.origin}>{t('link')}</Link>
    </>
  )
}

export default AmendStep3
